import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { tokens } from "@/shared/design-system/tokens";

export const FileUploadContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const DropZone = styled.div<{ isDragActive?: boolean }>`
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${tokens.spacing.sm};
  border: 2px dashed
    ${({ isDragActive }) =>
      isDragActive ? tokens.colors.blue[500] : "rgba(255, 255, 255, 0.40)"};
  border-radius: ${tokens.borderRadius.sm};
  background-color: ${({ isDragActive }) =>
    isDragActive ? "rgba(255, 255, 255, 0.80)" : "rgba(255, 255, 255, 0.50)"};
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: ${tokens.colors.basics[800]};
    background-color: rgba(255, 255, 255, 0.60);
  }
`;

export const Text = styled.p`
  color: #0B3E5F;
  text-align: center;
  font-family: ${tokens.typography.fontFamily.primary};
  font-size: ${tokens.typography.fontSize.md};
  font-style: normal;
  font-weight: 500;
  line-height: 200%;
  margin: 0;
  font-feature-settings: 'liga' off, 'clig' off;
`;

export const SubText = styled.p`
  color: #4B4B4B;
  text-align: center;
  font-family: ${tokens.typography.fontFamily.primary};
  font-size: ${tokens.typography.fontSize.xs};
  font-style: normal;
  font-weight: 500;
  line-height: 200%;
  margin: 0;
  font-feature-settings: 'liga' off, 'clig' off;
`;

/* File Preview Styles */
export const FilePreview = styled.div`
  display: flex;
  align-items: center;
  padding: ${tokens.spacing.mmd};
  background-color: rgba(255, 255, 255, 0.50);
  border: 1px solid rgba(255, 255, 255, 0.40);
  border-radius: ${tokens.borderRadius.sm};
  gap: ${tokens.spacing.md};
  position: relative;
`;

export const FileIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

export const FileDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  justify-content: center;
`;

export const FileMeta = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.sm};
  width: 100%;
`;

export const FileName = styled.span`
  font-family: ${tokens.typography.fontFamily.primary};
  font-size: ${tokens.typography.fontSize.xs};
  color: ${tokens.colors.basics[1400]};
  font-weight: ${tokens.typography.fontWeight.normal};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileSize = styled.span`
  font-family: ${tokens.typography.fontFamily.primary};
  font-size: ${tokens.typography.fontSize.xs};
  color: ${tokens.colors.basics[1100]};
  white-space: nowrap;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 7px;
  color: ${tokens.colors.basics[1900]};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    color: ${tokens.colors.semantic.error};
  }
`;

/* Progress Bar */
export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 4px;
  background-color: ${tokens.colors.basics[400]};
  border-radius: 2px;
  margin-top: 6px;
  overflow: hidden;
`;

export const progressAnimation = keyframes`
  0% { width: 0%; }
  100% { width: 100%; }
`;

export const ProgressFill = styled.div`
  height: 100%;
  background-color: ${tokens.colors.blue[500]};
  border-radius: 2px;
  /* Animation handled by width transition in inline styles or separate logic */
  transition: width 0.2s linear;
`;
